var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBigLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 61,
    viewBox: "0 0 80 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9649 0H29.6545V61H20.9649V0ZM58.2161 0V7.36015H64.953V61H73.3723V7.36015H80V0H58.2161ZM0 61H8.4195V33.3261H15.5901V26.0668H8.4195V7.36015H17.7738V0H0V61ZM59.3322 57.0042C59.334 58.3409 59.3348 59.6728 59.3345 61H51.4592C51.4523 58.6923 51.4471 56.3732 51.4436 54.0427C51.4371 51.7158 51.4262 49.3849 51.4012 47.0619C51.3515 42.4205 51.2457 37.7973 51.0048 33.3261H41.7424V61H34.1803V0H51.9484C53.0242 2.09849 53.9368 4.2779 54.6777 6.5186C55.4443 8.83429 56.0787 11.1922 56.5779 13.5809C57.0941 16.0093 57.5045 18.5133 57.8344 21.0611C58.1643 23.6081 58.4152 26.2141 58.6091 28.8433C58.8029 31.4712 58.941 34.1447 59.0414 36.8208C59.1417 39.4941 59.2058 42.2055 59.2477 44.8963C59.2896 47.5807 59.3106 50.308 59.3218 52.9821C59.3273 54.3262 59.3308 55.6669 59.3322 57.0042ZM50.4684 26.0668C49.7916 19.0921 48.6309 12.6366 46.6209 7.36015H41.7424V26.0668H50.4684Z",
    fill: "black",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigLogo);
export default __webpack_public_path__ + "static/media/big-logo.2c7afc9bade47e9a9c72eaa365911898.svg";
export { ForwardRef as ReactComponent };